const Style = {
  onboarding:
    'flex items-center justify-center bg-gradient-to-b from-brand-400 to-brand-600 min-h-full text-left',
}

export default Style
